<template>
  <div class="flex flex-1 flex-col justify-end">
    <div class="flex flex-1 flex-col px-4">
      <span
        v-if="hasShowConversationHistory"
        class="font-bold py-4"
        :class="$dm('text-black-900', 'dark:text-white')"
      >
        {{ $t('CONVERSATIONS') }}
        {{ allConversations.length > 0 ? `(${allConversations.length})` : '' }}
      </span>
      <div
        v-if="hasShowConversationHistory"
        class="flex overflow-auto flex-col list-wrapper"
        :class="{ 'justify-center -mt-6': shouldShowEmptyConversation }"
      >
        <div v-if="allConversations.length > 0">
          <conversation-item
            v-for="conversation in allConversations"
            :key="conversation.id"
            :conversation-id="conversation.id"
            :conversation-did="conversation.display_id"
            :conversation-status="conversation.status"
            :agent-name="conversation.agent.name"
            :agent-avatar="conversation.agent.avatar"
            :last-message="conversation.last_message"
            :status="conversation.status"
            :in-queue="conversation.in_queue"
            :archived="conversation.archived"
            :custom-attributes="conversation.custom_attributes"
            :unread-count="conversation.unread_count"
            :is-typing="conversation.is_agent_typing"
          />
        </div>
        <div
          v-else-if="shouldShowEmptyConversation"
          class="flex flex-col text-center"
        >
          <img
            :src="conversationAvatar"
            alt="No conversation"
            class="mb-3 self-center empty-images"
          />
          <h3 class="text-md font-semibold text-black-700">
            {{ $t('NO_CONVERSATION_TITLE') }}
          </h3>
          <p class="text-xs mt-2 text-black-500">
            {{ $t('NO_CONVERSATION_SUB_TITLE') }}
          </p>
        </div>
      </div>
    </div>
    <team-availability
      :available-agents="availableAgents"
      :has-conversation="!!conversationSize"
      @start-conversation="startConversation"
    />
  </div>
</template>

<script>
import configMixin from '../mixins/configMixin';
import TeamAvailability from 'widget/components/TeamAvailability';
import ConversationItem from 'widget/components/ConversationItem';
import { mapGetters } from 'vuex';
import routerMixin from 'widget/mixins/routerMixin';
import darkMixin from 'widget/mixins/darkModeMixin';

export default {
  name: 'Home',
  components: {
    TeamAvailability,
    ConversationItem,
  },
  mixins: [configMixin, routerMixin, darkMixin],
  props: {
    hasFetched: {
      type: Boolean,
      default: false,
    },
    isCampaignViewClicked: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      availableAgents: 'agent/availableAgents',
      activeCampaign: 'campaign/getActiveCampaign',
      conversationSize: 'conversation/getConversationSize',
      allConversations: 'conversation/getAllConversations',
      hasLoadedConversations: 'conversation/getHasLoadedConversations',
      isFetchingConversationList: 'conversation/getIsFetchingConversationList',
      currentUser: 'contacts/getCurrentUser',
    }),
    shouldShowEmptyConversation() {
      return (
        this.hasLoadedConversations &&
        !this.isFetchingConversationList &&
        this.allConversations.length === 0
      );
    },
    conversationAvatar() {
      return (
        this.inboxAvatarUrl || 'assets/images/widget/empty-conversation.svg'
      );
    },
  },
  mounted() {
    window.logger.logUserAction('info', 'Home mounted');

    if (this.hasShowConversationHistory) {
      this.$store.dispatch('conversation/getConversationList');
    }

    if (!this.currentUser?.id) {
      this.$store.dispatch('contacts/get');
    }
  },
  methods: {
    startConversation(isContinueConversation) {
      window.logger.logUserAction('info', 'Start conversation clicked', {
        data: {
          preChatFormEnabled: this.preChatFormEnabled,
          conversationSize: this.conversationSize,
          isRuleBasedAssistant: this.isRuleBasedAssistant(),
        },
      });

      if (
        !isContinueConversation &&
        this.preChatFormEnabled &&
        !this.isRuleBasedAssistant()
      ) {
        return this.replaceRoute('prechat-form');
      }

      return this.replaceRoute('messages');
    },
    isRuleBasedAssistant() {
      const { assistantType } = window.hooryWebChannel;
      return assistantType === 'rule-based';
    },
  },
};
</script>
<style lang="scss" scoped>
.list-wrapper {
  height: calc(100vh - 204px);
  padding-bottom: 0;
  padding-right: 8px;
  margin-right: -8px;
}
.empty-images {
  width: 184px;
  max-width: 94%;
  height: auto;
}
</style>
